import React from "react";

import Widget from "../core/Widget";

const ContainerWidgets = ({ data = [] }) => {
  return (
    <div>
      {data.map((widget, index) => (
        <Widget
          key={index}
          value={widget.value}
          descripcion={widget.descripcion}
          currency={widget.currency}
          icon={widget.icon}
        />
      ))}
    </div>
  );
};

export default ContainerWidgets;
